import { Login } from '@/src/components/Login/Login';

export default function HomePage() {
  return (
    <Login />
  );
}
